export enum FLEX_DIRECTION {
  ROW = "row",
  ROW_REVERSE = "row-reverse",
  COLUMN = "column",
  COLUMN_REVERSe = "column-reverse",
}

export enum FLEX_ALIGN {
  FLEX_START = "flex-start",
  FLEX_END = "flex-end",
  CENTER = "center",
  STRETCH = "stretch",
  BASELINE = "baseline",
}

export enum JUSTIFY_CONTENT {
  START = "start",
  END = "end",
  FLEX_START = "flex-start",
  FLEX_END = "flex-end",
  LEFT = "left",
  RIGHT = "right",
  CENTER = "center",
  NORMAL = "normal",
  SPACE_BETWEEN = "space-between",
  SPACE_AROUND = "space-around",
  SPACE_EVENLY = "space-evenly",
  STRETCH = "stretch",
}

export enum FLEX_WRAP {
  NOWRAP = "nowrap",
  WRAP = "wrap",
  WRAP_REVERSE = "WRAP_REVERSE",
}

export interface FlexStyledInterface {
  direction?: FLEX_DIRECTION;
  align?: FLEX_ALIGN;
  justify?: JUSTIFY_CONTENT;
  wrap?: FLEX_WRAP;
}

export interface FlexPropsInterface {
  children: React.ReactNode;
  styles?: FlexStyledInterface;
  className?: string;
}
